/**
 * Created by andrey on 02.08.2022
 */

// eslint-disable-next-line prefer-const
let ShowVictoryWindow = function (f, rewardsList) {
    new VictoryWindow(rewardsList);
    cleverapps.focusManager.onceNoWindowsListener = f;
};

// eslint-disable-next-line prefer-const
let ShowLoseWindow = function (f) {
    cleverapps.focusManager.compound(f, [
        function (f) {
            if (cleverapps.isRumble() && cleverapps.config.name !== "differences") {
                new BeforeLoseWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        },

        function (f) {
            new LoseWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    ]);
};

const ShowOutcomeWindow = function (f) {
    const outcome = this.game.outcome;
    const boatswain = this.game.boatswain;

    if (outcome === GameBase.OUTCOME_GAVEUP) {
        f();
    } else if (outcome === GameBase.OUTCOME_LOST) {
        ShowLoseWindow.call(this, f);
    } else if (this.game.shouldSkipVictoryWindow()) {
        boatswain.setIntent(Boatswain.NEXT_INTENT, { interstitial: false });
        f();
    } else {
        const victoryRewards = new VictoryWindowRewards();
        ShowVictoryWindow.call(this, f, victoryRewards);
        this.game.logCurrencyReward();

        return victoryRewards;
    }
};